import { jsx as _jsx } from "react/jsx-runtime";
import { TextBody } from '../../atoms';
export function Footnote(props) {
    return _jsx(TextBody, Object.assign({}, props, { small: true }));
}
